import React, { Component } from 'react';
import i18n from 'i18next';
import { I18n } from 'react-i18next';
import { Link, withRouter } from 'react-router-dom';
import EventRegister, { CHANGE_LANGUAGE } from '../helper/EventRegister';

class Menu extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentFlag: `/images/${localStorage.getItem('i18nextLng') || 'en'}.png`,
            lang: localStorage.getItem('i18nextLng') || 'en'
        };
    }

    componentDidMount() {
        const query = new URLSearchParams(document.location.search);
        const lang = query.get('lang');
        if(lang && ['en', 'ch', 'ja', 'ko'].includes(lang)) {
            this.changeStateFlag({ lang })
            this.onChangeLanguage(null, lang, i18n)
        }
        this.changeLanguageEvent = EventRegister.on(CHANGE_LANGUAGE, this.changeStateFlag);
    }

    componentWillUnmount() {
        EventRegister.off(this.changeLanguageEvent);
    }

    changeStateFlag = ({ lang }) => {
        this.setState({ currentFlag: `/images/${lang}.png` });
    };

    onChangeLanguage = (e, lang, i18n) => {
        this.props.history.push({
            search: `lang=${lang}`
        })
        e && e.preventDefault();
        i18n.changeLanguage(lang);
        this.changeStateFlag({ lang });
    };

    render() {
        const { currentItem } = this.props;
        const isDisplayOnWebview = window.location.href.endsWith('/a/faq') || window.location.href.endsWith('/a/faq?lng=en') || window.location.href.endsWith('/a/faq?lng=ja') || window.location.href.endsWith('/a/faq?lng=ko') || window.location.href.endsWith('/a/faq?lng=ch');

        return (
            <I18n ns="translations">
                {
                    (t, {i18n}) => (
                        <nav className="navbar nav-menu">
                            <div className="container">
                                <div className="navbar-header">
                                    {
                                        !isDisplayOnWebview && (
                                            <button type="button"
                                                className="navbar-toggle"
                                                data-toggle="collapse"
                                                data-target=".navbar-ex1-collapse"
                                            >
                                                <span className="sr-only">Toggle navigation</span>
                                                <span className="icon-bar" />
                                                <span className="icon-bar" />
                                                <span className="icon-bar" />
                                            </button>
                                        )
                                    }
                                    <Link className="navbar-brand logo" to={isDisplayOnWebview ? "#" : "/"}>
                                        <img src="/images/logo.png" alt="TRIAM NETWORK" style={{ width: 250 }}/>
                                    </Link>
                                    {/*<a className={"logo-fb"} href="https://facebook.com/development.triam.3" title="https://facebook.com/development.triam.3" target={"_blank"} >*/}
                                    {/*    <img className={"img-logo-sn-top"} src="/images/fb-logo.png" alt="Facebook"/>*/}
                                    {/*</a>*/}
                                    {/*<a className={"logo-tw"} href="https://twitter.com/triamnetwork1" title="https://twitter.com/triamnetwork1" target={"_blank"}>*/}
                                    {/*    <img className={"img-logo-sn-top"} src="/images/tw-logo.png" alt="Twitter"/>*/}
                                    {/*</a>*/}
                                </div>
                                <div className="collapse navbar-collapse navbar-ex1-collapse">
                                    <ul className="nav navbar-nav navbar-right">
                                        <li className={`animated rubberBand ${currentItem === 'home' ? "menu-active" : ""}`}>
                                                <span className="m_dot">
                                                    <div><span/></div>
                                                </span>
                                            <Link to="/">{t('Home')}</Link>
                                        </li>
                                        <li className={`animated rubberBand ${currentItem === 'service' ? "menu-active" : ""}`}>
                                                <span className="m_dot">
                                                    <div><span/></div>
                                                </span>
                                            <Link to="/service">{t('Service')}</Link>
                                        </li>
                                        <li className={`animated rubberBand ${currentItem === 'about' ? "menu-active" : ""}`}>
                                                <span className="m_dot">
                                                    <div><span/></div>
                                                </span>
                                            <a>{t('About')}</a>
                                        </li>
                                        <li className={`animated rubberBand ${currentItem === 'contact' ? "menu-active" : ""}`}>
                                                <span className="m_dot">
                                                    <div><span/></div>
                                                </span>
                                            <Link to="contact">{t('Contact')}</Link>
                                        </li>
                                        <li className="language">
                                            <a className="dropbtn">
                                                <img src={this.state.currentFlag} alt=""/>
                                                <span className="caret"/>
                                            </a>
                                            <ul className="dropdown-language">
                                                <li>
                                                    <a onClick={e => this.onChangeLanguage(e, 'en', i18n)}>
                                                        <img src="/images/en.png" alt="EN"/>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={e => this.onChangeLanguage(e, 'ja', i18n)}>
                                                        <img src="/images/ja.png" alt="JP"/>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={e => this.onChangeLanguage(e, 'ch', i18n)}>
                                                        <img src="/images/ch.png" alt="CH"/>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a onClick={e => this.onChangeLanguage(e, 'ko', i18n)}>
                                                        <img src="/images/ko.png" alt="KO"/>
                                                    </a>
                                                </li>
                                            </ul>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </nav>
                    )
                }
            </I18n>
        );
    }
}

export default withRouter(Menu);



// WEBPACK FOOTER //
// ./src/containers/menu.jsx